import axios from 'axios';

export const newFolder = async (body) => {
  const url = `${process.env.REACT_APP_API_URL}/folders`
  const headers = {
    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
    'Content-Type': 'application/json'
  };
  try {
    const response = await axios.post(url,{...body},{headers: headers});
    return response;
  } catch (error) {
    const {response} = error;
    return response;
  }
}


